/*=========================================================================================
  File Name: moduleSuspect.js
  Description: Suspect Module
  ----------------------------------------------------------------------------------------
  Author: Djezou Eric Martial
==========================================================================================*/


import state from './moduleSuspectState.js'
import mutations from './moduleSuspectMutations.js'
import actions from './moduleSuspectActions.js'
import getters from './moduleSuspectGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
